import { LOADING_STATUSES } from 'client/store/systemMessageSlice/systemMessageSlice';
import { useSelector } from 'react-redux';
import styles from './PlatformNotices.module.scss';
import Button from 'client/components/aria/Button/Button';
import WorkspaceStartIcon from '../WorkspaceStartIcon';
import { FormattedMessage, useIntl } from 'react-intl';
import { PLATFORM_NOTICES_PAGE } from 'client/utils/routes/routeConstants';
import Loading from 'client/components/ui/Loading/Loading';
import { usePlatformNotices } from 'client/pages/PlatformNoticesPage/usePlatformNotices';

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    const hour = date.getHours();
    const minutes = date.getMinutes();
    return `${day} ${month} ${year} - ${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

const PlatformNotices = () => {
    const platformNotices = usePlatformNotices();
    const noticesToShow = platformNotices.slice(0, 3);
    const platformNoticesStatus = useSelector(state => state.systemMessages.platformNotices.status);
    const intl = useIntl();

    return (
        <div className={styles.container}>
            {noticesToShow.length > 0 && (<ul className={styles.platformNoticesList} data-testid="workspace.platform-notices.list">
                {noticesToShow.map((notice) => (
                    <li key={notice.id} data-testid={`workspace.platform-notices.item.${notice.id}`} className={styles.platformNoticeItem}>
                        <span>
                            {formatDate(notice.start)}
                        </span>
                        <span>
                            {notice.event}
                        </span>
                    </li>
                ))}
            </ul>)}
            {noticesToShow.length === 0 && platformNoticesStatus === LOADING_STATUSES.succeeded && (
                <span data-testid="workspace.platform-notices.no-notices" >
                    <FormattedMessage id='workspace.platform-notices.no-notices' />
                </span>
            )}
            {platformNoticesStatus === LOADING_STATUSES.failed && (
                <span data-testid="workspace.platform-notices.error" >
                    <FormattedMessage id='workspace.platform-notices.error' />
                </span>
            )}
            {platformNoticesStatus === LOADING_STATUSES.loading && (
                <div className={styles.loader}>
                    <Loading variant='compact' data-testid="workspace.platform-notices.loading" />
                </div>
            )}
            <Button
                className={styles.platformNoticesButton}
                variant="secondary"
                data-testid="workspace.platform-notices.button"
                to={PLATFORM_NOTICES_PAGE}
                aria-label={intl.formatMessage({ id: 'workspace.platform-notices.button' })}
            >
                <WorkspaceStartIcon />
            </Button>
        </div>
    );
};

export default PlatformNotices;
